import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

export function insufficientFundsValidator(control: AbstractControl, field: FormlyFieldConfig) {
  const max: number = Number(field?.options?.formState?.maxBalance ?? 0);
  const value: number = Number(control.value || 0);

  if (!value || value <= max) {
    return null;
  }

  return { 'insufficient-funds': true };
}